import { render, staticRenderFns } from "./PaymentGateWayList.vue?vue&type=template&id=be364196&"
import script from "./PaymentGateWayList.vue?vue&type=script&lang=js&"
export * from "./PaymentGateWayList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports